<template>
  <Drawer title="海康-离线" width="1024"  :closable="false" v-model="_value">

    <Skeleton animated>
      <List item-layout="vertical">
        <ListItem v-for="item in data" :key="item.title">
          <ListItemMeta :title="item.title"/>
          {{ item.description }}<br/>
          {{ item.content }}<br/>
          {{ item.dispose }}
          <Button v-if="item.pdfSrc" type="primary" size="small" @click="openpdf(item.pdfSrc)" style="margin: 10px;">详细文档</Button>
          <iframe-modal v-model="Iframemodal" :initValue="IframeId"></iframe-modal>
          <template #extra>
            <img :src="item.imgSrc" style="width: 680px">
          </template>
        </ListItem>
      </List>
    </Skeleton>

  </Drawer>
</template>

<script>

  /**
   * 引入自建组件/框架组件等位置
   */
  import Vue from 'vue'
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'

  import IframeModal from '@/view/om/technicalassistance/components/iframe-modal'

  export default {
    name: 'hikofflinemodal',
    /**
     * 与组件引入的组件名一致，使用该组件
     * 下面是引入自建组件例子
     */
    components: {
      IframeModal,
    },
    /**
     * 作为组件对应传送字段
     */
    props: {
      initValue: null,
      terminalNumValue: null,
      value: {
        type: Boolean,
        default: false
      },

      Iframemodal:false,
      IframeId:false,
    },
    /**
     * 默认数据/字段名创建
     */
    data() {
      return {
        data: [
          {
            title: 'SIM卡失效',
            description: '1、联系相关人员查询该SIM卡是否在正常使用状态。',
            content: '2、安排上门维修更换SIM卡',
            imgSrc: '/HIK/SIMLoseEfficacy.jpg',
          },
          {
            title: '4G通信天线异常',
            description: '1、检查4G通信天线与设备主机是否松脱,重新插拔4G通信天线',
            content: '2、安排上门维修更换4G通信天线',
            imgSrc: '/HIK/SIMLoseEfficacy.jpg',
          },
          {
            title: '未检测到SIM卡',
            description: '1、重启设备等待2-5分钟，观察是否恢复',
            content: '2、检查SIM卡是否松脱，重新插拔SIM卡',
            dispose: '3、安排上门维修更换SIM卡',
            imgSrc: '/HIK/NotDetectedSIM.jpg',
          },
          {
            title: '设备运维离线',
            description: '1、下发短信注册运维',
            content: '2、方案一指令：AUTHEN:1;A',
            dispose: '3、方案二：①、ZIP:1,iot81.hikvisionauto.com,18884;A②、TEL_ID:1,0+,芯片码转换的11位数字后7位;A',
            imgSrc: "/HIK/OperationPlatformOffLine.jpg",
            // pdfSrc: "/RM/RM-IPSET.pdf",
          },
          {
            title: '设备参数异常',
            description: '1、查询设备离线平台通道的IP，端口，协议，协议版本等是否正确。把错误的参数重新设置',
            content: '2、海康运维->维护中心->设备配置->操作->配置->文件配置',
            imgSrc: "/HIK/Parameterexception.jpg",
            pdfSrc: "/HIK/HIK-IPSET.pdf",
          },
          {
            title: '平台与设备主机号不一致',
            description: '1、查询离线平台录入资料，与设备填写主机号（中心识别码）是否一致。修改正确的资料（两客一危平台为准）',
            content: '2、客观序列号：0+（11位主机号），终端ID：主机号后7位',
            imgSrc: '/HIK/IDInconformity.jpg',
            pdfSrc: "/HIK/HIK-IPSET.pdf",
          },
          {
            title: '设备无电源',
            description: '1、车辆通电，设备显示屏无反应，安排上门维修检查电源线',
            imgSrc: '/HIK/NonTransformer.jpg',
          },
          {
            title: '设备模块损坏',
            description: '1、安排上门维修更换设备主机',
            // imgSrc: '/BSJ/A6BD/Parameterexception.jpg',
          }
        ]
      }
    },
  /**
   * 方法存储位置
   */
  methods: {
      ...mapActions([
        'VehicleInfoServ_SearchByName'
      ]),
    openpdf(e) {
      this.Iframemodal = true
      this.IframeId = e
    },
    },
    /**作为组件的数值传输字段
     */
    computed: {
      _value: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _terminalNumValue: {
        get() {
          return this.terminalNumValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
  /**
   * 页面加载执行的代码
   * 可调用方法存储位置中的方法
   */
  mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>

<!--样式库-->
<style scoped>
  .numstyleone{
    list-style-type: upper-roman;
    width:100%;
  }
  .numstyletwo{
    list-style-type: upper-alpha;
  }
  .numstyleone.numstyletwo.li{
    width:80px;
    float:left;
  }
</style>
